//
// Single source of truth for the SESSION and SCHEDULE alias grammar. Mirrors the server validator in
// blobhub-infra, where both objects reuse DEFINITION_ALIAS_SCHEMA verbatim — one handle grammar, not
// two, which is why one module serves both.
//
// NOTE: this is NOT the session-OBJECT path grammar (context/sessionObjectAlias.js) — that one allows
// upper case, dots and `/` path separators and runs 1–256 characters. Do not cross the two.
//
// The bounds reject an empty string, so this validator answers "too short" for "". An alias is
// OPTIONAL everywhere it appears: callers must skip validation for blank input and omit the key from
// the command body, rather than sending "" and asking the server to reject it.

export const SESSION_ALIAS_MIN_LENGTH = 6;
export const SESSION_ALIAS_MAX_LENGTH = 42;

// Unanchored body for an HTML5 `pattern` attribute (the browser anchors it as ^(?:…)$).
export const SESSION_ALIAS_HTML5_PATTERN = "[a-z0-9_-]*";

// Anchored form for programmatic checks, built from the same body so the two can never drift.
export const SESSION_ALIAS_PATTERN = new RegExp(`^(?:${SESSION_ALIAS_HTML5_PATTERN})$`);

export function validateSessionAlias(alias) {
  if (typeof alias !== "string") {
    return "Alias must be a string.";
  }
  if (alias.length < SESSION_ALIAS_MIN_LENGTH || alias.length > SESSION_ALIAS_MAX_LENGTH) {
    return `Alias must be ${SESSION_ALIAS_MIN_LENGTH}–${SESSION_ALIAS_MAX_LENGTH} characters ` +
      `(so "main" and "dev" are too short — try "primary" or "staging").`;
  }
  if (!SESSION_ALIAS_PATTERN.test(alias)) {
    return "Alias may contain only lower-case letters, digits, underscores and hyphens.";
  }
  return null;
}

export function isValidSessionAlias(alias) {
  return validateSessionAlias(alias) === null;
}
